<template>
<div>		
	<div class="backBox">
		<img
			class="pointer"
			@click="toSetting()"
			src="@/assets/thdImg/pages/back.svg"
			alt=""
		/>
		<span class="backBox_name">模块设置</span>
	</div>
	<div class="integralEden">
			<div class="content">
				<el-tabs v-model="tabActive" type="card" @tab-click="handleClick">
					<el-tab-pane label="等级列表" name="1"></el-tab-pane>
					<el-tab-pane label="权益列表" name="2"></el-tab-pane>
					<el-tab-pane label="全局配置" name="3"></el-tab-pane>
				</el-tabs>

				<!-- 等级列表 -->
				<div v-if="tabActive == 1">
					<levelList></levelList>
				</div>

				<!-- 权益列表 -->
				<div v-if="tabActive == 2">
					<equityList></equityList>
				</div>

				<!-- 全局配置 -->
				<div v-if="tabActive == 3">
					<configuration></configuration>
				</div>

			</div>
	</div>
</div>
</template>

<script>
import levelList from "./components/levelList";
import equityList from "./components/equityList";
import configuration from "./components/configuration";
export default {
name: '' ,
components: {
	levelList,
	equityList,
	configuration
},
props:{},
data() {
return {
	tabActive: "1",
}
},
computed: {},
created() {

},
mounted() {

},
methods: {
  handleClick(tab) {

	},
	toSetting() {
		this.$emit("returnBack");
	},
}
}
</script>
<style lang='scss' scoped>
.integralEden {
  box-sizing: border-box;
  padding: 20px;
  min-width: 1110px;
  .content {
    min-height: 720px;
    background: rgba(255, 255, 255, 1);
    border-radius: 6px;
  }
}
</style>